import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadMonitoring: IMonitoringLoadActionCreator = () => {
        return {
            type: ACTION_MONITORING_LOAD
        }
    },
    LoadMonitoringsByTrialInstitutionId: IMonitoringsLoadByTrialInstitutionIdActionCreator = (trialInstitutionId) => {
        return {
            type: ACTION_MONITORINGS_LOAD_BY_TRIALINSTITUTION_ID,
            trialInstitutionId
        }
    },
    LoadMonitoringById: IMonitoringLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_MONITORING_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IMonitoringLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_MONITORING_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IMonitoringLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORING_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveMonitoring: IMonitoringSaveActionCreator = (formData) => {
        return {
            type: ACTION_MONITORING_SAVE,
            formData
        }
    },
    SaveSuccess: IMonitoringSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_MONITORING_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IMonitoringSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORING_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateMonitoring: IMonitoringCreateActionCreator = (trialInstitutionId) => {

        return {
            type: ACTION_MONITORING_CREATE,
            trialInstitutionId
        }
    },
    CreateSuccess: IMonitoringCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_MONITORING_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IMonitoringCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORING_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateMonitoring: IMonitoringValidateActionCreator = (formData) => {
        return {
            type: ACTION_MONITORING_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IMonitoringValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_MONITORING_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IMonitoringValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORING_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IMonitoringClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_MONITORING_CLEAR,
            propertiesToClear
        }
    },

    Filter: IMonitoringFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_MONITORING_FILTER,
            formFilter
        }
    };



export const
    ACTION_MONITORING_LOAD = "ACTION_MONITORING_LOAD",
    ACTION_MONITORINGS_LOAD_BY_TRIALINSTITUTION_ID = "ACTION_MONITORINGS_LOAD_BY_TRIALINSTITUTION_ID",
    ACTION_MONITORING_LOAD_BY_ID = "ACTION_MONITORING_LOAD_BY_ID",
    ACTION_MONITORING_LOAD_SUCCESS = "ACTION_MONITORING_LOAD_SUCCESS",
    ACTION_MONITORING_LOAD_FAILURE = "ACTION_MONITORING_LOAD_FAILURE",

    ACTION_MONITORING_SAVE = "ACTION_MONITORING_SAVE",
    ACTION_MONITORING_SAVE_SUCCESS = "ACTION_MONITORING_SAVE_SUCCESS",
    ACTION_MONITORING_SAVE_FAILURE = "ACTION_MONITORING_SAVE_FAILURE",

    ACTION_MONITORING_CREATE = "ACTION_MONITORING_CREATE",
    ACTION_MONITORING_CREATE_SUCCESS = "ACTION_MONITORING_CREATE_SUCCESS",
    ACTION_MONITORING_CREATE_FAILURE = "ACTION_MONITORING_CREATE_FAILURE",

    ACTION_MONITORING_VALIDATE = "ACTION_MONITORING_VALIDATE",
    ACTION_MONITORING_VALIDATE_SUCCESS = "ACTION_MONITORING_VALIDATE_SUCCESS",
    ACTION_MONITORING_VALIDATE_FAILURE = "ACTION_MONITORING_VALIDATE_FAILURE",

    ACTION_MONITORING_CLEAR = "ACTION_MONITORING_CLEAR",

    ACTION_MONITORING_FILTER = "ACTION_MONITORING_FILTER";

export interface IMonitoringLoadAction {
    type: "ACTION_MONITORING_LOAD";
}

export interface IMonitoringLoadActionCreator {
    (): IMonitoringLoadAction;
}

export interface IMonitoringLoadSuccessAction {
    type: "ACTION_MONITORING_LOAD_SUCCESS";
    formData: Dtos.Monitoring | Dtos.Monitoring[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringLoadSuccessActionCreator {
    (
        formData: Dtos.Monitoring | Dtos.Monitoring[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringLoadSuccessAction;
}

export interface IMonitoringLoadFailureAction {
    type: "ACTION_MONITORING_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringLoadFailureAction;
}

export interface IMonitoringsLoadByTrialInstitutionIdAction {
    type: "ACTION_MONITORINGS_LOAD_BY_TRIALINSTITUTION_ID";
    trialInstitutionId: number;
}

export interface IMonitoringsLoadByTrialInstitutionIdActionCreator {
    (trialInstitutionId: number): IMonitoringsLoadByTrialInstitutionIdAction;
}

export interface IMonitoringLoadByIdAction {
    type: "ACTION_MONITORING_LOAD_BY_ID";
    id: number;
}

export interface IMonitoringLoadByIdActionCreator {
    (id: number): IMonitoringLoadByIdAction;
}


export interface IMonitoringSaveAction {
    type: "ACTION_MONITORING_SAVE";
    formData: Dtos.Monitoring;

}

export interface IMonitoringSaveActionCreator {
    (
        formData: Dtos.Monitoring
    ): IMonitoringSaveAction;
}

export interface IMonitoringSaveSuccessAction {
    type: "ACTION_MONITORING_SAVE_SUCCESS";
    formData: Dtos.Monitoring;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringSaveSuccessActionCreator {
    (
        formData: Dtos.Monitoring,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringSaveSuccessAction;
}

export interface IMonitoringSaveFailureAction {
    type: "ACTION_MONITORING_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringSaveFailureAction;
}

export interface IMonitoringCreateAction {
    type: "ACTION_MONITORING_CREATE",
    trialInstitutionId: number
}

export interface IMonitoringCreateActionCreator {
    (trialInstitutionId: number): IMonitoringCreateAction
}

export interface IMonitoringCreateSuccessAction {
    type: "ACTION_MONITORING_CREATE_SUCCESS";
    formData: Dtos.Monitoring;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IMonitoringCreateSuccessActionCreator {
    (
        formData: Dtos.Monitoring,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IMonitoringCreateSuccessAction;
}

export interface IMonitoringCreateFailureAction {
    type: "ACTION_MONITORING_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringCreateFailureAction;
}

export interface IMonitoringValidateAction {
    type: "ACTION_MONITORING_VALIDATE";
    formData: Dtos.Monitoring;

}

export interface IMonitoringValidateActionCreator {
    (
        formData: Dtos.Monitoring
    ): IMonitoringValidateAction;
}

export interface IMonitoringValidateSuccessAction {
    type: "ACTION_MONITORING_VALIDATE_SUCCESS";
    formData: Dtos.Monitoring;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringValidateSuccessActionCreator {
    (
        formData: Dtos.Monitoring,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringValidateSuccessAction;
}

export interface IMonitoringValidateFailureAction {
    type: "ACTION_MONITORING_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringValidateFailureAction;
}

export interface IMonitoringClearAction {
    type: "ACTION_MONITORING_CLEAR";
    propertiesToClear?: string[];
}

export interface IMonitoringClearActionCreator {
    (propertiesToClear?: string[]): IMonitoringClearAction;
}

export interface IMonitoringFilterActionCreator {
    (formFilter: IFormFilter): IMonitoringFilterAction;
}

export interface IMonitoringFilterAction {
    type: "ACTION_MONITORING_FILTER";
    formFilter: IFormFilter;
}

export type MonitoringAction =
    IMonitoringLoadAction |
    IMonitoringsLoadByTrialInstitutionIdAction |
    IMonitoringLoadByIdAction |
    IMonitoringLoadFailureAction |
    IMonitoringLoadSuccessAction |
    IMonitoringSaveAction |
    IMonitoringSaveSuccessAction |
    IMonitoringSaveFailureAction |
    IMonitoringCreateAction |
    IMonitoringCreateSuccessAction |
    IMonitoringCreateFailureAction |
    IMonitoringValidateAction |
    IMonitoringValidateSuccessAction |
    IMonitoringValidateFailureAction |
    IMonitoringClearAction | 
    IMonitoringFilterAction;
